/**
 * ההודעה האמיתית מתוך כשל של Edge Function.
 *
 * supabase-js עוטף כל תשובה שאינה 2xx ב "Edge Function returned a
 * non-2xx status code", וההודעה בעברית שהשרת טרח לכתוב נבלעת.
 * ההבדל בין "אין לך הרשאה" לבין "לא הצלחנו להגיע לשרת" הוא ההבדל
 * בין לדעת מה לעשות לבין לנחש.
 */
export async function functionErrorMessage(error: unknown): Promise<string> {
  const context = (error as { context?: unknown }).context;

  if (context instanceof Response) {
    try {
      const body = (await context.json()) as { error?: { message_he?: string } };
      const message = body.error?.message_he;
      if (message) return message;
    } catch {
      // גוף שאינו JSON. נופלים להודעה לפי הסטטוס.
    }
    return `הפעולה נכשלה בשרת (${context.status}).`;
  }

  // לא הגיעה תשובה בכלל: רשת, CORS, או חוסם בדפדפן
  const name = (error as { name?: string }).name ?? '';
  if (name === 'FunctionsFetchError') {
    return 'לא הצלחנו להגיע לשרת. בדקו את החיבור ונסו שוב.';
  }

  const raw = (error as { message?: string }).message;
  return raw && raw.trim() !== '' ? raw : 'הפעולה נכשלה.';
}
